import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Section, Toggle } from '../settingsPrimitives';
import { usePreferencesStore } from '../../store/preferencesStore';
import {
  clampMailCatcherPort,
  clampMailCatcherKeep,
  MAIL_CATCHER_KEEP_MIN,
  MAIL_CATCHER_KEEP_MAX,
} from '../../services/appPreferencesStore';
import { setKeep } from '../../services/mailCatcherService';
import { isTauri } from '../../utils/tauri';

/**
 * Mail catcher settings, under Settings → Extensions → Mail (the
 * TerminalExtensionSettings shape). Port applies on the next start; the
 * retention count is also pushed to the Rust store right away so the next
 * prune uses it.
 */
export default function MailCatcherExtensionSettings() {
  const { t } = useTranslation();
  const port = usePreferencesStore((s) => s.mailCatcherPort);
  const autoStart = usePreferencesStore((s) => s.mailCatcherAutoStart);
  const keep = usePreferencesStore((s) => s.mailCatcherKeep);
  const update = usePreferencesStore((s) => s.updatePreference);

  const commitKeep = (value) => {
    const next = clampMailCatcherKeep(value);
    update('mailCatcherKeep', next);
    if (isTauri()) setKeep(next).catch(() => {});
  };

  return (
    <Section title={t('mailCatcher.settingsServer')}>
      <Row label={t('mailCatcher.portLabel')} desc={t('mailCatcher.settingsPortDesc')}>
        <div className="settings-input-group">
          <input
            type="number"
            min={1}
            max={65535}
            value={port ?? 1025}
            onChange={(e) => {
              const n = parseInt(e.target.value, 10);
              if (!Number.isNaN(n)) update('mailCatcherPort', n);
            }}
            onBlur={(e) => update('mailCatcherPort', clampMailCatcherPort(e.target.value))}
            className="settings-number-input"
            style={{ width: 80 }}
            aria-label={t('mailCatcher.portLabel')}
          />
        </div>
      </Row>
      <Row label={t('mailCatcher.settingsAutoStart')} desc={t('mailCatcher.settingsAutoStartDesc')}>
        <Toggle value={autoStart === true} onChange={(v) => update('mailCatcherAutoStart', v === true)} />
      </Row>
      <Row
        label={t('mailCatcher.settingsKeep')}
        desc={t('mailCatcher.settingsKeepDesc', { min: MAIL_CATCHER_KEEP_MIN, max: MAIL_CATCHER_KEEP_MAX })}
      >
        <div className="settings-input-group">
          <input
            type="number"
            min={MAIL_CATCHER_KEEP_MIN}
            max={MAIL_CATCHER_KEEP_MAX}
            value={keep ?? 500}
            onChange={(e) => {
              const n = parseInt(e.target.value, 10);
              if (!Number.isNaN(n)) update('mailCatcherKeep', n);
            }}
            onBlur={(e) => commitKeep(e.target.value)}
            className="settings-number-input"
            style={{ width: 80 }}
            aria-label={t('mailCatcher.settingsKeep')}
          />
        </div>
      </Row>
    </Section>
  );
}
